import React from 'react';
import { dayShort, toDateKey } from '../../utils/date';

/**
 * Mon–Sun row. days: [{ date: Date, available: boolean }].
 * When `onSelect` is given the cells are selectable buttons.
 */
export default function WeekStrip({ days, selected, onSelect, variant = 'tile' }) {
  return (
    <div className={`week-strip week-strip--${variant}`}>
      {days.map(({ date, available }) => {
        const key = toDateKey(date);
        const isSelected = selected === key;
        const cls = [
          'week-strip__day',
          available ? 'week-strip__day--available' : 'week-strip__day--off',
          isSelected && 'week-strip__day--selected',
        ].filter(Boolean).join(' ');
        const content = (
          <>
            <span className="week-strip__dow">{dayShort(date)}</span>
            <span className="week-strip__num">{date.getDate()}</span>
          </>
        );
        return onSelect ? (
          <button key={key} type="button" className={cls} disabled={!available} onClick={() => onSelect(key)}>
            {content}
          </button>
        ) : (
          <div key={key} className={cls}>{content}</div>
        );
      })}
    </div>
  );
}
